import React, { useContext, useState } from "react";
import MediumButton from "../../components/buttons/MediumButton";
import { AuthContext } from "../../context/AuthContext";
import { FaCheck } from "react-icons/fa6";
import { VscVerifiedFilled } from "react-icons/vsc";
import config from "../../config";
import propTypes from "prop-types";

const ProductDisplay = ({ setPaymentStep, setClientSecret }) => {
  const { user } = useContext(AuthContext);
  const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async (event) => {
    event.stopPropagation();
    console.log("handling subscribe intent...");
    if (!user) {
      setErrorMessage("Please log in to subscribe.");
      return;
    }
    setIsLoading(true);
    setErrorMessage("");

    try {
      console.log("creating payment intent now.");
      // Step 1: Create a Payment Intent on the backend
      const response = await fetch(
        `${config.apiUrl}/subscriptions/create-payment-intent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: user._id.toString(),
            productId: "prod_Rwbh8pk544VF1B", // Your product ID
          }),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || "Failed to create payment intent");
      }

      const { clientSecret } = await response.json();
      setClientSecret(clientSecret);
      console.log("clientSecret: ", clientSecret);
      setPaymentStep(2);
    } catch (error) {
      setErrorMessage(`Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
      <div className="product">
        <div className="pfp-container">
          <img
            src={
              user && user.profilePicture
                ? user.profilePicture
                : `${cloudfrontUrl}/static/no-profile-pic.webp`
            }
            className="sub-user-pic"
          />
          <VscVerifiedFilled className="verification-badge" />
        </div>
        <div className="description">
          <h3 className="sub-headline">Weekly Subscription</h3>
          <h3 className="sub-headline">$1.99 / week</h3>
        </div>
        <div className="benefits">
          <ul className="benefits-list">
            <li>
              <FaCheck className="benefit-icon" /> See who used your link
            </li>
            <li>
              <FaCheck className="benefit-icon" /> Track views on your active
              links
            </li>
            <li>
              <FaCheck className="benefit-icon" /> View other user profiles
            </li>
            <li>
              <FaCheck className="benefit-icon" /> Verification badge
            </li>
            <li>
              <FaCheck className="benefit-icon" /> Access to private Discord
              server
            </li>
          </ul>
        </div>
        <div className="cta-container">
        <MediumButton
          id="checkout-and-portal-button"
          onClick={(event) => {
              console.log("button clicked");
              handleSubscribe(event);
          }}
          text={isLoading ? "Processing..." : "Subscribe"}
          color="purple"
          // disabled={isLoading || !stripe || !elements}
        />
        </div>
        {errorMessage && <p className="sub-error-message">{errorMessage}</p>}
      </div>
  );
};

export default ProductDisplay;

ProductDisplay.propTypes = {
  setPaymentStep: propTypes.func,
  setClientSecret: propTypes.func,
};
